﻿export const getBasket = (state) => {
    return state.basket;
};

export const getCustomer = (state) => {
    return state.customer;
};